import {inlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export default class GetUserByIdUserUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {UseCase} deps.service
   * @param {Object} deps.log
   */
  constructor({getUserByIdUserService, getCurrentUserService, userNotLoggedInUserErrorFactory}) {
    super()

    this._getUserByIdUserService = getUserByIdUserService
    this._getCurrentUserService = getCurrentUserService
    this._userNotLoggedInUserErrorFactory = userNotLoggedInUserErrorFactory
  }

  getCurrentUser = async () => {
    const currentUser = await this._getCurrentUserService.execute()
    return currentUser || null
  }

  @tracer({metric: 'GetUserByIdUserUseCase#execute'})
  @inlineError
  async execute() {
    const currentUser = await this.getCurrentUser()

    if (!currentUser)
      throw this._userNotLoggedInUserErrorFactory({
        message: `[GetUserByIdUserService#get] user not logged`
      }).toJSON()

    const [error, userData] = await this._getUserByIdUserService.execute({
      currentUser
    })
    if (error) return error
    return userData.toJSON()
  }
}
